import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["after", "divider"]
  static values = { position: { type: Number, default: 50 } }

  connect() {
    this.apply(this.positionValue)
    this.startX = 0
    this.startY = 0
    this.locked = false
  }

  start(event) {
    if (event.pointerType === "mouse" && event.button !== 0) return
    this.dragging = true
    this.locked = false
    this.startX = event.clientX
    this.startY = event.clientY
    this.element.setPointerCapture?.(event.pointerId)
  }

  move(event) {
    if (!this.dragging) return

    if (!this.locked && event.pointerType === "touch") {
      const dx = Math.abs(event.clientX - this.startX)
      const dy = Math.abs(event.clientY - this.startY)
      if (dy > dx + 4) {
        // Vertical scroll wins; let the page scroll
        this.dragging = false
        this.element.releasePointerCapture?.(event.pointerId)
        return
      }
      if (dx < 4) return
      this.locked = true
    }

    event.preventDefault()
    const rect = this.element.getBoundingClientRect()
    const x = event.clientX - rect.left
    const pct = Math.max(0, Math.min(100, (x / rect.width) * 100))
    this.apply(pct)
  }

  end() {
    this.dragging = false
    this.locked = false
  }

  apply(pct) {
    this.positionValue = pct
    this.afterTarget.style.clipPath = `inset(0 0 0 ${pct}%)`
    this.dividerTarget.style.left = `${pct}%`
  }
}
